import { Node } from 'reactflow';

import { LocalPromptDependency } from '../../../../../../services/backendService/types';
import { NODE_WIDTH, NODES_HORIZONTAL_GAP } from './generateAllNodes';

type GeneratePromptOutputNodesProps = {
  flattedPromptOutputs: LocalPromptDependency[];
  largestRowWidth: number;
};

const generatePromptOutputNodes = ({
  flattedPromptOutputs,
  largestRowWidth,
}: GeneratePromptOutputNodesProps) => {
  const rowWidth =
    flattedPromptOutputs.length * NODE_WIDTH +
    (flattedPromptOutputs.length - 1) * NODES_HORIZONTAL_GAP;
  let currentX = (largestRowWidth - rowWidth) / 2;
  const currentY = 400;

  const nodes: Node[] = [];
  for (const eachPromptOutput of flattedPromptOutputs) {
    nodes.push({
      id: eachPromptOutput.id,
      data: {
        label: `${eachPromptOutput.label}`,
      },
      style: {
        backgroundColor: '#490fea4d',
        fontWeight: 'bold',
      },

      position: { x: currentX, y: currentY },
    });
    currentX += NODE_WIDTH + NODES_HORIZONTAL_GAP;
  }

  return nodes;
};

export default generatePromptOutputNodes;
